import { render, staticRenderFns } from "./phoneNumberBillTj.vue?vue&type=template&id=07064e84"
import script from "./phoneNumberBillTj.vue?vue&type=script&lang=js"
export * from "./phoneNumberBillTj.vue?vue&type=script&lang=js"
import style0 from "./phoneNumberBillTj.vue?vue&type=style&index=0&id=07064e84&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports